// @flow

import unifizeUser from "./index";
import PhoneNumber from "src/components/user/PhoneNumber";

export default unifizeUser(PhoneNumber);
